import { lazy } from "react";

const Employees = lazy(() => import("./Employees"));
const EmployeForm=lazy(()=>import("./EmployeForm"))
const EmployesRoutes = [
  {
    path: "/employees/employees",
    element: <Employees />,
  },
  {
    path: "/employees/new",
    element: <EmployeForm />,
  },
  
 
];

export default EmployesRoutes;
